import { Skeleton } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { useGetCapitalProvidersQuery } from 'packages/organization/requests/organization.gql.generated';
import { PortfolioSummaryContainer } from 'packages/portfolio/ui/summary/PortfolioSummaryContainer';

export const InsightsFundingOverviewContainer = () => {
  const { creditFacilityId } = useCreditFacilityContext();

  const {
    loading: isCapitalProvidersLoading,
    data: capitalProvidersData,
  } = useGetCapitalProvidersQuery({
    variables: { creditFacilityId },
  });

  if (isCapitalProvidersLoading || !capitalProvidersData) {
    return <Skeleton height="600px" />;
  }

  const capitalProviderOrganizationIds = _.map(
    capitalProvidersData.capitalProviders,
    (cp) => cp.id,
  );

  return (
    <PortfolioSummaryContainer
      capitalProviderOrganizationIds={capitalProviderOrganizationIds}
      creditFacilityId={creditFacilityId}
      dashboard="borrower"
    />
  );
};
